import { faArrowRight, faChevronRight } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { twMerge } from "tailwind-merge";

const ProductInfoButtons = ({ children, className, onClick }) => {
  return (
    <button className={twMerge("flex justify-between items-center leading-normal text-base md:text-[1.375rem] text-heading font-black", className)} onClick={onClick}>
      <span>{children}</span>
      <span className="flex items-center justify-center w-8 h-8 bg-transparent rounded-full">
        <FontAwesomeIcon icon={faArrowRight} className="w-auto h-3 text-heading" />
      </span>
    </button>
  );
};

export default ProductInfoButtons;